import React, { useState } from 'react'
import AboutTheTriko from './panels/about-triko/AboutTheTriko'
import { NavItem, NavLink, Nav, TabContent, TabPane } from 'reactstrap'
import ServicesPanel from './panels/services'
import RequiredDocs from './panels/required-doc/RequiredDocs'
import ServiceRequests from './panels/service-requests'
import { useTranslate } from '@core/hooks'

const TabsRenderer: React.FC<{ loading: boolean }> = ({}) => {
    const [currentTab, setCurrenTab] = useState('about')
    const [trikoIDNumber, setTrikoIdNumber] = useState<any>()
    const t = useTranslate()
    const [visiblePanels, setVisiblePanels] = useState<{
        about: boolean
        services: boolean
        requiredDoc: boolean
        serviceRequests: boolean
    }>({ about: true, services: false, requiredDoc: false, serviceRequests: false })

    const tabsToRender: { label: string; id: string }[] = [
        { label: t('detail.aboutTheTriko'), id: 'about' },
        { label: t('detail.services'), id: 'services' },
        { label: t('detail.requiredDocumentation'), id: 'requiredDoc' },
        { label: t('detail.serviceRequests'), id: 'serviceRequests' }
    ]

    const handleChangePanel = (tabId: any) => {
        if (visiblePanels[tabId] === false) {
            setVisiblePanels({ ...visiblePanels, [tabId]: true })
        }
        setCurrenTab(tabId)
    }

    return (
        <>
            <Nav tabs>
                {tabsToRender.map((tab, key) => (
                    <NavItem key={`nav-link${key}`}>
                        <NavLink
                            onClick={() => handleChangePanel(tab.id)}
                            active={currentTab === tab.id}
                        >
                            {tab.label}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            <TabContent activeTab={currentTab}>
                <TabPane tabId="about">
                    {visiblePanels.about && (
                        <AboutTheTriko
                            onLoadInformation={({ data }: any) => {
                                const { attributes } = data || {}
                                const { personalInformation } = attributes
                                setTrikoIdNumber(personalInformation.idnumber)
                            }}
                        />
                    )}
                </TabPane>
                <TabPane tabId="services">{visiblePanels.services && <ServicesPanel />}</TabPane>
                <TabPane tabId="requiredDoc">
                    {visiblePanels.requiredDoc && <RequiredDocs />}
                </TabPane>
                <TabPane tabId="serviceRequests">
                    {visiblePanels.serviceRequests && (
                        <ServiceRequests trikoIDNumber={trikoIDNumber} />
                    )}
                </TabPane>
            </TabContent>
        </>
    )
}

export default TabsRenderer
